import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import useHttp from "../../../../../hooks/useHttp";
import shortid from "shortid";

import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

import { hideModal } from "../../../../../store/slices/modal";
import { DISPUTES_POST_URL } from "../../../../../utils/api-ends";
import LoaderImg from "../../../../../assets/media/loader.gif";
import store from "../../../../../store";
import {
  canSeeDisputButtonValue,
  singleDisputObjValue,
  canSeeWithdrawButtonValue,
} from "../../../../../store/slices/Dispute";

const CreateDisputeRequest = ({ modalData }) => {
  const dispatch = useDispatch();
  const closeModal = () => dispatch(hideModal());
  const userData = useSelector((state) => state.basicInfo.userDetails);
  const { error, isLoading, sendRequests } = useHttp();
  const [successMessage, setSuccessMessage] = useState(false);
  const [disputeError, setDisputeError] = useState([]);
  const [disputeReasonError, setDisputeReasonError] = useState([]);
  const [disputeTypeError, setDisputeTypeError] = useState([]);
  const [disputeType, setDisputeType] = useState("");
  const [disputeReason, setDisputeReason] = useState("");

  const onChangeDisputeReason = (e) => {
    setDisputeReason(e.target.value);
  };
  const onChangeStatus = (e) => {
    setDisputeType(e.target.value);
  };

  const openLoadManageModal = (e) => {
    setDisputeReasonError([]);
    setDisputeTypeError([]);
    setDisputeError([]);
    const response = (data) => {
      store.dispatch(
        singleDisputObjValue({
          singleDisputObj: data,
        })
      );

      setSuccessMessage(true);
      setTimeout(function () {
        closeModal();
      }, 3000);
      store.dispatch(
        canSeeDisputButtonValue({
          canSeeDisputButton: false,
        })
      );

      store.dispatch(
        canSeeWithdrawButtonValue({
          canSeeWithdrawButton: true,
        })
      );
    };

    sendRequests(
      {
        method: "post",
        url: DISPUTES_POST_URL,
        data: {
          order_obj: modalData.id,
          reason_of_dispute: disputeReason,
          dispute_type: disputeType,
        },
      },
      response
    );
  };

  useEffect(() => {
    if (error) {
      setSuccessMessage("");
      if (error.reason_of_dispute) {
        setDisputeReasonError(error.reason_of_dispute);
      }
      if (error.dispute_type) {
        setDisputeTypeError(error.dispute_type);
      }
      if (error.non_field_errors) {
        setDisputeError(error.non_field_errors);
      }
      if (error.general) {
        setDisputeError(error.general);
      }
    }
  }, [error]);

  // Show or hide error messages on mouse enter or leave
  const showErrorMessage = (e) =>
    e.currentTarget.setAttribute("show-tittle", "true");
  const hideErrorMessage = (e) =>
    e.currentTarget.setAttribute("show-tittle", "false");

  return (
    <div className="col-xl-6 col-lg-8 col-md-10">
      <div className="load-add-edit-modal">
        <div className="input-box-area" single-labe="true">
          {successMessage == true ? (
            <p className="auth-instruction SuccessMessage_SuccessMsg__fTMdE withdrawAmount-success-message">
              Dispute Request Successfully Created
            </p>
          ) : (
            <></>
          )}

          {disputeError?.length > 0 && (
            <p className="auth-error withdraw-message-style">{disputeError}</p>
          )}

          <div className="input-box-area" single-labe="true">
            <label> Dispute Type</label>
            <Select
              value={disputeType}
              label="City"
              name="city"
              className="input-box-area-select-field mui-select-field-without-label"
              fullWidth
              onChange={onChangeStatus}
            >
              <MenuItem value="cancel_order" key={shortid.generate()}>
                Unsatisfied Order
              </MenuItem>
              {userData?.user_type == "carrier" ? (
                <MenuItem value="finish_order" key={shortid.generate()}>
                  Finish Order
                </MenuItem>
              ) : (
                <></>
              )}
            </Select>
            {disputeTypeError?.length > 0 && (
              <div
                className="error"
                show-tittle="false"
                onMouseEnter={showErrorMessage}
                onMouseLeave={hideErrorMessage}
              >
                <i className="fa-solid fa-circle-exclamation"></i>
                {disputeTypeError?.map((error, index) => (
                  <p className="auth-error" key={index}>
                    {error}
                  </p>
                ))}
              </div>
            )}
          </div>
          <div className="input-box-area" single-labe="true">
            <label> Dispute Reason</label>
            <input
              type="text"
              placeholder="Dispute Reason"
              id="withdraw-amount-input"
              onChange={onChangeDisputeReason}
            />
            {disputeReasonError?.length > 0 && (
              <div
                className="error"
                show-tittle="false"
                onMouseEnter={showErrorMessage}
                onMouseLeave={hideErrorMessage}
              >
                <i className="fa-solid fa-circle-exclamation"></i>
                {disputeReasonError?.map((error, index) => (
                  <p className="auth-error" key={index}>
                    {error}
                  </p>
                ))}
              </div>
            )}
          </div>
        </div>
        <div className="multiple-btn modal-button ">
          <button data-id={modalData.id} onClick={openLoadManageModal}>
            {isLoading && (
              <img src={LoaderImg} alt="" style={{ width: "20px" }} />
            )}
            Create
          </button>
          <button onClick={closeModal}> Cancel </button>
        </div>
      </div>
    </div>
  );
};

export default CreateDisputeRequest;
